/** Holds the router's navigate fn so modules can navigate without importing main.js. */

/** @type {(to: string, opts?: { replace?: boolean }) => void} */
let navigate = (to, { replace = false } = {}) => {
  if (replace) window.location.replace(to);
  else window.location.assign(to);
};

/** @param {typeof navigate} fn */
export function setNavigator(fn) {
  navigate = fn;
}

/** @param {string} to @param {{ replace?: boolean }} [opts] */
export function go(to, opts) {
  navigate(to, opts);
}
